/**
 * @file Created on Thu Aug 09 2018
 * @author VBr
 */
import PrivilegesControl from './PrivilegesControl';
export default PrivilegesControl;